import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import OtaUploadList from '@blade-sxp/ota-management/components/ota-upload-list.vue';
let default_1 = class extends Vue {
    onFullScreenFlag = false;
    devicesList = [];
    keywords = '';
    handleSearch() {
        this.$refs.deviceList1.refresh();
    }
    handleClear() {
        this.keywords = '';
    }
    mounted() { }
    handleExit() { }
};
default_1 = __decorate([
    Component({
        name: 'OTAUploadManagement',
        components: {
            OtaUploadList,
        },
        i18n: {
            messages: {
                'en-us': {
                    search: 'Search',
                    searchHolder: 'File Name/Version',
                },
                zh: {
                    search: '搜索',
                    searchHolder: '文件名/版本',
                },
            },
        },
    })
], default_1);
export default default_1;
